export default "__VITE_ASSET__D2QaVyn7__"